import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import NoDataAvailable from '../NoDataAvailable';
import { Spinner } from 'react-bootstrap';
import ChartTitle from '../../../../../elements/ChartTitle';

const GRAPH_TITLE = 'Defect Aging';

const DefectAgingChart = ({ data, dateFilters, loading, isJiraIntegrated, handleRefresh, isFetching }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (!data.length) {
      setChartData([]);
      return;
    }

    const now = Date.now();
    const agingCategories = {
      '<7 days': { category: '<7 days', Total: 0 },
      '7-14 days': { category: '7-14 days', Total: 0 },
      '>14 days': { category: '>14 days', Total: 0 },
    };

    data
      .filter(({ resolution }) => resolution && resolution === 'Unresolved')
      .forEach(({ created }) => {
        const ageInDays = Math.floor(
          (now - new Date(created).getTime()) / 86400000
        );
        const agingKey =
          ageInDays < 7
            ? '<7 days'
            : ageInDays <= 14
            ? '7-14 days'
            : '>14 days';

        agingCategories[agingKey].Total += 1;
      });

    setChartData(Object.values(agingCategories));
  }, [data]);

  const totalCount = chartData.reduce((sum, item) => sum + item.Total, 0);

  return (
    <div className="chart-div">
      <ChartTitle
        title={GRAPH_TITLE}
        showWarning={!isJiraIntegrated}
        dateFilters={dateFilters}
        onRefresh={handleRefresh}
        isFetching={isFetching}
        showRefreshButton={!loading && isJiraIntegrated}
      />
      {loading ? (
        <Spinner className="mt-5" />
      ) : chartData.length === 0 ? (
        <NoDataAvailable />
      ) : (
        <>
          <p className="text-muted mb-0">
            Total Unresolved Defects: {totalCount}
          </p>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              width={900}
              height={500}
              barSize={25}
              data={chartData}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="category"
                label={{
                  value: 'Age (days)',
                  position: 'insideBottom',
                  offset: -10,
                }}
                tick={{ fontSize: 12 }}
              />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Legend wrapperStyle={{ padding: 10 }} />
              <Bar dataKey="Total" fill="#ba4a00" name="Unresolved Defects" />
            </BarChart>
          </ResponsiveContainer>
        </>
      )}
    </div>
  );
};

export default DefectAgingChart;
